// Typelizer digest 6647859113986994c6bbfcad5e965224
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /passkeys/registration_challenge */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/passkeys/registration_challenge', {}, options),
    method: 'post',
  }),
}
